const TOKEN_KEY = 'mall_admin_token'
const USER_KEY = 'mall_admin_user'

export function getAdminToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function setAdminToken(token) {
  localStorage.setItem(TOKEN_KEY, token || '')
}

export function clearAdminToken() {
  localStorage.removeItem(TOKEN_KEY)
}

export function getAdminUser() {
  const raw = localStorage.getItem(USER_KEY)
  if (!raw) {
    return null
  }
  try {
    return JSON.parse(raw)
  } catch (error) {
    return null
  }
}

export function setAdminUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user || {}))
}

export function clearAdminUser() {
  localStorage.removeItem(USER_KEY)
}

export function clearAdminAuth() {
  clearAdminToken()
  clearAdminUser()
}
